export default function popover({ variables }) {
    return {
        MuiPopover: {
            styleOverrides: {
                paper: {
                    border: `1px solid ${variables.border_subtle}`,
                    borderRadius: variables.border_radius_small,
                    backgroundImage: "none",
                },
            },
        },
    };
}
//# sourceMappingURL=popover.js.map